import { makeStyles } from '@mui/styles'
const useStyles = makeStyles(() => ({
  root: {
    width: '90%',
    marginLeft: '5%',
    marginTop: '2%'
  },
  title: {
    fontWeight: 'bold',
    color: '#32332E',
    fontSize: '1.2em'
  },
  boxavatar: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  avatar: {
    height: 60,
    width: 60,
    // color: '#2F3D40'
    backgroundColor: '#2F3D40',
    color: '#FFFFFF'
  },
  gridContainer: {
    width: '100%',
    paddingTop: '2%',
    marginLeft: 2
  },
  gridContainerButtons: {
    width: '100%',
    paddingTop: '3%',
    marginLeft: 2
  },
  titles: {
    marginTop: 2,
    marginBottom: 1,
    fontSize: '0.85em',
    color: '#1F2024',
    fontWeight: 'bold'
  },
  values: {
    fontSize: 14,
    color: '#2F3D40'
  },
  listMobile: {
    display: 'flex',
    alignItems: 'center'
  },
  buttonMobileMore: {
    width: 70,
    height: 25,
    borderRadius: 24,
    backgroundColor: '#fff',
    border: '2px solid #2F3D40',
    boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
  },
  button: {
    width: '35%',
    display: 'flex',
    alignItems: 'flex-end',
    padding: 4,
    textDecoration: 'none',
    cursor: 'pointer',
    color: '#10403B',
    '&:hover': {
      color: '#1C846F'
    }
  },

  iconsButton: {
    fontSize: '1.6rem'
  },
  typographyButton: {
    paddingLeft: 1,
    letterSpacing: 0.5,
    fontSize: '0.79rem',
    fontWeight: 'bold',
    '&:hover': {
      fontSize: '0.80rem'
    }
  },

  containerbuttonClose: {
    position: 'absolute',
    width: '95%',
    marginLeft: '5%',
    bottom: 20,
    display: 'flex'
  },
  buttonClose: {
    width: 90,
    height: 35,
    backgroundColor: '#1C846F',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    borderRadius: 1,
    display: 'flex',
    '&:hover': {
      backgroundColor: '#1BF57F'
    },
    justifyContent: 'center',
    alignItems: 'center'
  },
  typographyButtonClose: {
    color: '#FFFFFF',
    cursor: 'pointer',
    fontSize: 16
  }
}))

export default useStyles
